export const REDIRECT_TO_FROM_404_PAGE_QUERY_PARAM = 'redirectTo';
export const MSDK_REPORT_ID_PARAM = 'reportId';
export const MSDK_TEST_NAME_PARAM = 'testName';
